module.exports = __webpack_public_path__ + "img/teamwork-icon-5.b59a2007.png";